import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice ({
    name: "user",
    initialState: {
        user: {},
        photos: [],
        favorites: [],
        loggedin: false,
    },
    reducers: {
        updateUser: (state, action) => {
            // console.log(action.payload.photos)
            return{
                ...state,
                user: action.payload,
                photos: action.payload.photos,
                favorites: action.payload.favorites,
                loggedin: true
            }
            },
        loginUser: (state, action) => {
            return{
                user: action.payload,
                photos: action.payload.photos,
                favorites: action.payload.favorites,
                loggedin: true
            }
            },
        addPhoto: (state, action) => {
            state.photos.push(action.payload)
            },
        logoutUser: (state) => {
            return { 
                user: [], 
                photos: [], 
                favorites: [],
                loggedin: false
                }
            },
        deletePhoto: (state, action) => {
            const photos = state.photos.filter((p) => p.id !== action.payload);
            return{
                ...state,
                ...photos
                }
            },
        deleteFavPhoto: (state, action) => { 
            const favorites = state.favorites.filter((f) => f.id !== action.payload);
            console.log(action.payload.id)
            return{
                ...state,
                ...favorites
                }
            },
        updateUserPhoto: (state, action) => {
            const photos = state.photos.filter((p) => p.id !== action.payload);
            return{
                ...state,
                ...photos
                }
            }
        }
    })

    const updateUser = userSlice.actions.updateUser
    const addPhoto = userSlice.actions.addPhoto
    const logoutUser = userSlice.actions.logoutUser
    const deletePhoto = userSlice.actions.deletePhoto
    const deleteFavPhoto = userSlice.actions.deleteFavPhoto
    const updateUserPhoto = userSlice.actions.updateUserPhoto
    const loginUser = userSlice.actions.loginUser

    export { updateUser, loginUser, addPhoto, logoutUser, deletePhoto, deleteFavPhoto, updateUserPhoto}
    export default userSlice.reducer;